import React from 'react';
import './PlatformHeader.css';
import { useSession } from '../../context/SessionContext';

/**
 * The ExtraMilePlay header shared by all platform games: company logo that
 * links home, plus a Back button to this game's detail page. Inside the
 * mobile app the native shell owns navigation, so the logo posts
 * `navigate_back` and the Back button is hidden.
 */
export default function PlatformHeader({ right = null }) {
  const { companyLogoUrl, backButtonUrl, fromMobileApp } = useSession();

  const onMobileNavigateBack = (e) => {
    e.preventDefault();
    try {
      window.GameStatus?.postMessage?.('navigate_back');
    } catch {
      /* not running inside the app shell */
    }
  };

  return (
    <header className="upperaction">
      <a
        href={process.env.REACT_APP_BASE_URL}
        className="logo-link"
        aria-label="Home"
        onClick={fromMobileApp ? onMobileNavigateBack : undefined}
      >
        {companyLogoUrl ? <img src={companyLogoUrl} className="logo-holder" alt="" /> : null}
      </a>
      {!fromMobileApp && backButtonUrl ? (
        <div className="back-holder">
          <button type="button" className="back-default" onClick={() => { window.location.href = backButtonUrl; }}>
            Back
          </button>
        </div>
      ) : null}
      {right && <div className="upperaction-right">{right}</div>}
    </header>
  );
}
